import { TabNav } from '@customerio/pluma-components/react';
import { useLocation } from 'react-router-dom';
import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { AppBundle, AppBundleRoutes } from '@/utils/app-bundles';

export function AnalysisTabs() {
  const location = useLocation();
  const workspaceId = getWorkspaceIdFromCurrentUrl();
  const journeysPrefix = AppBundleRoutes[AppBundle.Journeys];

  const tabs = [
    {
      href: `/workspaces/${workspaceId}${journeysPrefix}/analysis`,
      text: 'Performance',
      isActive:
        location.pathname === `/workspaces/${workspaceId}${journeysPrefix}/analysis` ||
        location.pathname.startsWith(`/workspaces/${workspaceId}${journeysPrefix}/analysis/index`),
    },
    {
      href: `/workspaces/${workspaceId}/analysis/deliverability`,
      text: 'Deliverability',
      isActive: location.pathname.includes('/analysis/deliverability'),
    },
  ];

  return <TabNav tabs={tabs} />;
}
